import React, { useState,useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BiArrowBack } from 'react-icons/bi'
import { MdEmail } from 'react-icons/md'
import { GrSecure } from 'react-icons/gr'
import { loginProvider } from '../redux/provider/provider.action'
import logo from '../images/logo4.png'
import logo1 from '../images/name.png'
import { toast } from 'react-hot-toast'
import { clearError } from '../redux/provider/provider.reducer'
import { logout } from '../redux/user/user.action'
import { clearCart } from '../redux/Cart/Cart.reducer'
import { clearOtpError } from '../redux/otp/otp.reducer'
import { sendOtp } from '../redux/otp/otp.action'
function ProviderLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isSigning, setIsSigning] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openforgetpass,setopenforgetpass]=useState(false);
  const otpinfo=useSelector((state)=> state.otp)
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSigning(true);
    dispatch(loginProvider({ email, password }))
    setEmail("")
    setPassword("")
  }
  const provider = useSelector((state) => state.provider);

  useEffect(() => {
    if (provider.isProvider) {
      setIsSigning(false)
      toast.success("Logged In Successfully")
      dispatch(logout())
      dispatch(clearCart())
      navigate('/provider/dashboard/orders');
    } else if (provider && provider.error) {
      toast.error("Invalid Credentials")
      setIsSigning(false)
      dispatch(clearError())
    }
  }, [provider, dispatch, navigate])


  useEffect(()=>{
    if( otpinfo && otpinfo.otpinfo )
    {
      toast.success("Otp send successfully")
      navigate("/otpinput")
      dispatch(clearOtpError())
    }
     else if(otpinfo.otperror){
      
       toast.error("Email not found")
        dispatch(clearOtpError())
     }
   
  },[dispatch,navigate,otpinfo])

  function navigateToOtp(e)
  {

       e.preventDefault();
         dispatch(sendOtp({email}))
         setEmail("")
         console.log(email)
    
      }
  return (
    <div  >
    <div className='py-2 sm:px-8 px-2  shadow flex justify-between items-center '>
      <Link to="/" className='flex items-center'>
      <img src={logo} className='h-16 object-contain' alt="" />
        
        {/* <h1 className='font-bold text-xl font-mono'>Tiffin Buddy</h1> */}
      </Link>
      <Link to="/" className='flex items-center gap-2'>
        <BiArrowBack />
        <span>Back to home</span>
      </Link>
    </div>
    <div className='flex flex-col gap-10 sm:justify-center items-center sm:py-0 py-8 ' style={{ height: 'calc(100vh - 50px)' }}>
     {openforgetpass ?  <h1 className='text-center w-full text-slate-900 md:text-3xl text-xl font-semibold'>Forgot Password</h1> : 
     <h1 className='text-center w-full text-slate-900 md:text-3xl text-xl font-semibold'>Provider Login</h1>} 
      <div className='lg:w-1/3 md:w-2/5 sm:w-2/3 w-4/5 '>
        {openforgetpass ? 
          <form action="" className='flex flex-col gap-5' onSubmit={navigateToOtp}>
          <div className='flex items-center border bg-white w-full'>
            <span className='px-2 h-full'><MdEmail /></span>
            <input type="email" value={email} name="email" placeholder='Enter Your Email' className='w-full h-full px-2 py-2 border-l focus:outline-none' id="email" required onChange={(e) => setEmail(e.target.value)} />
          </div>
          
          <div className='text-blue-500 font-semibold text-start'>
            <Link  onClick={()=>setopenforgetpass(false)}>SignIn ?</Link>
          </div>
          <div className={`bg-orange-500 text-white py-2 shadow rounded-full ${otpinfo.otpfetching ? 'opacity-70 cursor-not-allowed' : ''}`}>
            <input type="submit"  value={`${otpinfo.otpfetching ? 'Sending...' : 'Send Otp For Email Varification'}`} className={`h-full w-full cursor-pointer ${otpinfo.otpfetching ? 'opacity-70 cursor-not-allowed' : ''}`} />
          </div>
          <div className='text-slate-900 font-semibold text-center'>
          <Link to="/registerProvider">Don't Have Account? Register as Provider</Link>
          </div>
        </form> :
        <form action="" className='flex flex-col gap-5' onSubmit={handleSubmit}>
        <div className='flex items-center border bg-white w-full'>
          <span className='px-2 h-full'><MdEmail /></span>
          <input type="email" value={email} name="email" placeholder='Enter Your Email' className='w-full h-full px-2 py-2 border-l focus:outline-none' id="email" required onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className='flex items-center border bg-white w-full'>
          <span className='px-2 h-full'><GrSecure /></span>
          <input type="password" value={password} name="password" placeholder='Enter Your password' className='w-full h-full px-2 py-2 border-l focus:outline-none' id="password" required onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div className='text-blue-500 font-semibold text-start'>
          <Link  onClick={()=>setopenforgetpass(true)}  >Forgot your password ?</Link>
        </div>
        <div className={`bg-orange-500 text-white py-2 shadow rounded-full ${isSigning ? 'opacity-70 cursor-not-allowed' : ''}`}>
          <input type="submit" value={`${isSigning ? 'Signing...' : 'Sign In'}`} className={`h-full w-full cursor-pointer ${isSigning ? 'opacity-70 cursor-not-allowed' : ''}`} />
        </div>
        <div className='text-slate-900 font-semibold text-center'>
        <Link to="/registerProvider">Don't Have Account? Register as Provider</Link>
        </div>
      </form>}
      </div>
    </div>
  </div>

  )
}

export default ProviderLogin
